import type { AuditGridItemProps } from '../../types'

export function AuditGridItemHidden({
  children,
  className
}: AuditGridItemProps): JSX.Element {
  return <div className={className}>{children}</div>
}
